import { useEvent } from '~features/events/hooks/useEvent';
import type { FiltersEventMap } from '~components/Filters/FiltersEvents';

const Events = {
  Viewed: 'Dashboard: Viewed',
  CrawlerSelected: 'Dashboard: Crawler Selected',
  CrawlerPickerOpened: 'Dashboard: Crawler Picker Opened',
  DomainSelected: 'Dashboard: Domain Selected',
  TimeframeSelected: 'Dashboard: Timeframe Selected',
  PresetClicked: 'Dashboard: Preset Clicked',
  PeriodStepped: 'Dashboard: Period Stepped',
  PeriodReset: 'Dashboard: Period Reset',
  SeeMoreClicked: 'Dashboard: See More Clicked',
  ChartDatasetToggled: 'Dashboard: Chart Dataset Visibility',
  ChartDescriptionsToggled: 'Dashboard: Chart Descriptions Toggled',
  ScheduledRendersToggled: 'Dashboard: Scheduled Renders Toggled',
  ExportAsPdf: 'Dashboard: Export as PDF clicked',
  CrawlerPickerBannerViewed: 'Dashboard: Crawler Picker Banner Viewed',
  CrawlerPickerBannerDismissed: 'Dashboard: Crawler Picker Banner Dismissed',
} as const;

type Event = keyof typeof Events;
type EventPayloadMap = FiltersEventMap & {
  Viewed: { time_frame: string; selected_crawlers: string[]; selected_domain: string };
  SeeMoreClicked: { location_tab: string; kpi_card_name: string };
  ChartDatasetToggled: { chart: string; dataset: string; action: 'hide' | 'show' };
  ScheduledRendersToggled: { action: 'hidden' | 'shown' };
  CrawlerPickerBannerViewed: Record<string, never>;
  CrawlerPickerBannerDismissed: Record<string, never>;
};

function useTrackDashboardV3Event() {
  const { track } = useEvent();
  function trackDashboardV3Event<E extends keyof FiltersEventMap>(event: E, data: FiltersEventMap[E]): void;
  function trackDashboardV3Event<E extends Event>(event: E, data: EventPayloadMap[E]): void;
  function trackDashboardV3Event(event: Event, data: EventPayloadMap[Event]): void {
    if (event === 'Viewed') track(Events[event], { ...data, version: 'v3' });
    else track(Events[event], data);
  }

  return trackDashboardV3Event;
}

export default useTrackDashboardV3Event;
